import React from 'react';
import PropTypes from 'prop-types';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import MaterialTextField from 'shared/components/connectedTextField/c/materialTextField/MaterialTextField';
import MaterialNumberField from 'shared/components/connectedTextField/c/materialNumberField/MaterialNumberField';
import ManageConnectionProfiles from "./ManageConnectionProfilesConnector";
import { CONNECTION_SUCCESS } from "redux/connections/ConnectionsConstants";

const inputStyle = { width: '50%', display: 'block' };

class ConnectionEditor extends React.Component {
  constructor(props) {
    super(props);
    const { id, label, description, userName, pswrd, port, address, sftpProfiles: [{ profileId, directoryPath, fileKeyString }] } = props.connection;
    this.state = {
      connection: {
        id,
        label,
        description,
        userName,
        pswrd,
        port,
        address,
        sftpProfiles: [{
          profileId,
          directoryPath,
          fileKeyString
        }]
      }
    };
  }

  handleCheckConnection = () => {
    this.props.OnCheckConnection();
  };

  handleInputChange = (ev, value) => {
    const target = ev.target;
    this.props.onChangeField(target.name, value);
  };

  handleProfileChange = (newSftpProfiles) => {
    this.props.onProfileChange(newSftpProfiles);
  };

  render() {
    const { connectionResult, checkingConnection, checkDisabled } = this.props;
    const { label, description, userName, pswrd, port, address} = this.props.connection;
    return (
      <div className="connection-editor">
        <MaterialTextField
          name={ 'label' }
          label={ 'Label' }
          value={ label }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
          required
        />
        <MaterialTextField
          name={ 'description' }
          label={ 'Description (Optional)' }
          value={ description }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
        />
        <MaterialTextField
          name={ 'userName' }
          label={ 'User Name' }
          value={ userName }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
          required
        />
        <MaterialTextField
          name={ 'pswrd' }
          label={ 'Password' }
          type="password"
          value={ pswrd }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
          required
        />
        <MaterialNumberField
          name={ 'port' }
          label={ 'SFTP Port' }
          value={ port }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
          required
        />
        <MaterialTextField
          name={ 'address' }
          label={ 'SFTP Address' }
          value={ address }
          onChange={ this.handleInputChange }
          fullWidth={ false }
          style={ inputStyle }
          required
        />
        <div className="connection-editor__check-button-container">
          <SovosRaisedButton color="secondary" disabled={ checkDisabled } onClick={ this.handleCheckConnection } style={ { marginTop: 20 } }>CHECK CONNECTION</SovosRaisedButton>
          {
            checkingConnection ?
              <p>{ 'Checking Connection...' }</p> :
              <p style={ { color: connectionResult === CONNECTION_SUCCESS ? 'green' : 'red' } }>{ connectionResult }</p>                 
          }
        </div>
        <ManageConnectionProfiles
          connection={ this.props.connection }
          onProfileChange={ this.handleProfileChange }
        />
      </div>
    );
  }
}

ConnectionEditor.propTypes = {
  onChangeField: PropTypes.func.isRequired,
  OnCheckConnection: PropTypes.func.isRequired,
  connection: PropTypes.object.isRequired,
  isCreation: PropTypes.bool.isRequired,
  checkDisabled: PropTypes.bool,
  onProfileChange: PropTypes.func.isRequired,
  connectionResult: PropTypes.string.isRequired,
  checkingConnection: PropTypes.bool.isRequired
};

ConnectionEditor.defaultProps = {
  checkingConnection: false,
  checkDisabled: false
};
export default ConnectionEditor;



// WEBPACK FOOTER //
// ./src/components/manageConnection/comp/connectionEditor/ConnectionEditor.js